import { Application } from "@/types/startup";
import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";

interface ApplicationDetailsProps {
  application: Application;
  onAction: (status: string) => void;
}

export const ApplicationDetails = ({ application, onAction }: ApplicationDetailsProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <h3 className="font-medium">Applicant:</h3>
        <span className="text-gray-400">
          {application.profiles?.full_name || "Anonymous"}
        </span>
      </div>
      <div>
        <h3 className="font-medium">Message</h3>
        <p className="text-gray-400">{application.message}</p>
      </div>
      <div>
        <h3 className="font-medium">Experience</h3>
        <p className="text-gray-400">{application.experience}</p>
      </div>
      {application.cv_url && (
        <div>
          <h3 className="font-medium">CV</h3>
          <a
            href={application.cv_url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-flux-cyan hover:underline"
          >
            View CV
          </a>
        </div>
      )}
      {application.status === 'pending' && (
        <DialogFooter className="flex space-x-2">
          <Button
            variant="outline"
            className="border-red-500 text-red-500 hover:bg-red-500/10"
            onClick={() => onAction('rejected')}
          >
            Reject
          </Button>
          <Button
            className="bg-flux-cyan hover:bg-flux-cyan/80"
            onClick={() => onAction('accepted')}
          >
            Accept
          </Button>
        </DialogFooter>
      )}
      {application.status !== 'pending' && (
        <div className="text-center p-2 rounded bg-gray-800/50">
          Status: <span className="capitalize">{application.status}</span>
        </div>
      )}
    </div>
  );
};